// ============================================================
// Datei: src/pages/ressorts/kaffimobil/Kaffimobil.jsx
// PURPOSE:
// Reine Weiche für Desktop / Mobile
// ============================================================

import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import "../../../styles/global.css";
import "../../../styles/ressortTabs.css";
import "../../../styles/ccMailCard.css";

import useVolunteers from "../../../components/fetch/useVolunteers";
import useShifts from "../../../components/fetch/useShifts";
import useMediaQuery from "../../../hooks/useMediaQuery";
import Api from "../../../Api";

import KaffimobilDesktop from "./KaffimobilDesktop";
import KaffimobilMobile from "./KaffimobilMobile";

const Kaffimobil = () => {
	const isMobile = useMediaQuery("(max-width: 768px)");
	const navigate = useNavigate();

	// ============================================================
	// VOLUNTEERS
	// ============================================================
	const volunteersHook = useVolunteers("kaffimobil");
	const volunteers = volunteersHook[0];
	const setVolunteers = volunteersHook[1];

	const reloadVolunteersFromBackend = useCallback(async () => {
		try {
			const res = await Api.get("/volunteers?department=kaffimobil");
			setVolunteers([...res.data]);
		} catch (err) {
			console.error("❌ Reload Volunteers Fehler:", err);
		}
	}, [setVolunteers]);

	const reloadVolunteers =
		typeof volunteersHook[2] === "function"
			? volunteersHook[2]
			: reloadVolunteersFromBackend;

	// ============================================================
	// SHIFTS
	// ============================================================
	const [shifts] = useShifts("kaffimobil");

	// ============================================================
	// STATE
	// ============================================================
	const [selectedVolunteer, setSelectedVolunteer] = useState(null);
	const [guests, setGuests] = useState([]);
	const [activeTab, setActiveTab] = useState("overview");

	// ============================================================
	// GUESTS
	// ============================================================
	const loadGuests = useCallback(() => {
		Api.get("/guests")
			.then((res) => setGuests(res.data))
			.catch((err) => console.error("❌ Gäste Fehler:", err));
	}, []);

	// ============================================================
	// SECURITY + INITIAL LOAD
	// ============================================================
	useEffect(() => {
		const role = localStorage.getItem("role");
		const dept = localStorage.getItem("department");

		if (role !== "OK" || dept?.toLowerCase() !== "kaffimobil") {
			alert("Zugriff verweigert!");
			navigate("/");
			return;
		}

		loadGuests();
		reloadVolunteers();
	}, [navigate, loadGuests, reloadVolunteers]);

	// ============================================================
	// CC DOWNLOAD
	// ============================================================
	const downloadCcEmails = async () => {
		try {
			const res = await Api.get("/cc-emails", {
				responseType: "blob"
			});

			const blob = new Blob([res.data], { type: "text/plain" });
			const url = window.URL.createObjectURL(blob);

			const a = document.createElement("a");
			a.href = url;
			a.download = "helferfest_cc_liste.txt";
			document.body.appendChild(a);
			a.click();
			a.remove();

			window.URL.revokeObjectURL(url);
		} catch (err) {
			console.error("CC-Download Fehler:", err);
			alert("Download fehlgeschlagen");
		}
	};

	// ============================================================
	// SHARED PROPS
	// ============================================================
	const sharedProps = {
		volunteers,
		setVolunteers,
		reloadVolunteers,

		shifts,
		guests,
		reloadGuests: loadGuests,

		selectedVolunteer,
		setSelectedVolunteer,

		activeTab,
		setActiveTab,

		downloadCcEmails
	};

	return (
		<div
			className="kaffimobil-page bg-reveal"
			data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_kaffimobil.jpg`}
		>
			<h2 className="kaffimobil-heading">Kaffimobil</h2>

			{isMobile ? (
				<KaffimobilMobile {...sharedProps} />
			) : (
				<KaffimobilDesktop {...sharedProps} />
			)}
		</div>
	);
};

export default Kaffimobil;